export const ReportsInformationTableColumns = [
  { key: 'sn', label: '' },
  { key: 'action', label: 'Action' },
  { key: 'jobOrder', label: 'Job Order #' },
  { key: 'vesselName', label: 'Vessel' },
  { key: 'serialNumber', label: 'Serial Number' },
  { key: 'siteName', label: 'Job Site' },
  { key: 'model', label: 'Model Number' },
  { key: 'analyst', label: 'Analyst' },
  { key: 'inspectionDate', label: 'Inspection Date' },
];
